(function () {
	'use strict';
	var mobileMQ = '(max-width: 700px)';
	$('.open-menuz').on('click', function (e) {
		e.preventDefault();
		e.stopPropagation();
		$('.main-nav')
			.toggleClass('hidden')
			.toggleClass('show');

	});
	$('.open-merchant-sub-menuz').on('click', function (e) {
		e.preventDefault();
		e.stopPropagation();
		var mq = window.matchMedia( mobileMQ );
		if(mq.matches) {
			$('.mobile-merchant-menu-inner')
				.toggleClass('hidden')
				.toggleClass('show');
		}


	});
	var menuToggle = function ($el, lockBody) {
		if (lockBody === undefined) {
			lockBody = false;
		}
		if ($el.hasClass('pp-shown')) {
			$el.removeClass('pp-shown');
			if (lockBody) {
				$('body').removeClass('no-scroll');
			}

		} else {
			$el.addClass('pp-shown');
			window.scrollTo(0,0);
			if(lockBody) {$('body').addClass('no-scroll');}
		}
	};

	// open mobile menu
	$('.open-menu').on('click', function(e) {
		e.preventDefault();
		var menu = $('.pp-menu, .multi-campus-menu');
		menuToggle(menu, true);
		$('.open-menu').toggleClass('open');
		$('.profile-close').removeClass('open');

	});
	$('.open-menu-merchant-mobile').on('click', function(e) {
		e.preventDefault();
		var menu = $('.pp-menu-merchant-mobile');
		menuToggle(menu);

	});
	$('.security-submenu').on('click', function(e) {
		e.preventDefault();
		var menu = $('.pp-securitysubmenu');
		menuToggle(menu);

	});

	var multicampusMQ = '(max-width: 1024px)';
	$('.open-profile-menu').on('click', function(e) {
		e.preventDefault();
		var mq = window.matchMedia(multicampusMQ);
		if (mq.matches) {
			var menu = $('.pp-profilemenu');
			menuToggle(menu, true);
		}
		$('.profile-close').toggleClass('open');
		$('.open-menu').removeClass('open');
		$('.multi-campus-menu').removeClass('pp-shown');

	});
	$('.pp-back').on('click', function (e) {
		var $this = $(this);

		var menu = $('.' +  $this.attr('data-pp-menu'));
		menuToggle(menu);
		e.preventDefault();
	});


	$('.pp-menu-close, .profile-close, .open-menu.open').on('click', function (e) {
		e.preventDefault();
		$('.pp-shown').removeClass('pp-shown');
		$('.profile-close').removeClass('open');
		$('.open-menu').removeClass('open');
		$('body').removeClass('no-scroll');
	});

	$('body').on('searchActivated', function () {
		$('.pp-shown').removeClass('pp-shown');
	});

	$(document).click(function(e) {
		if($('.main-nav').hasClass('show')) {
			$('.main-nav')
				.toggleClass('hidden')
				.toggleClass('show');
		}
		$('body').removeClass('no-transitions');

		if (!($('.open-menu').is(e.target) || $('.open-menu').has(e.target).length > 0
			|| $('.open-profile-menu').is(e.target) || $('.open-profile-menu').has(e.target).length > 0
			|| $('.multi-campus-menu').is(e.target) || $('.multi-campus-menu').has(e.target).length > 0
			|| $('.profile-flyout').is(e.target) || $('.profile-flyout').has(e.target).length > 0)) {
			$('.multi-campus-menu').removeClass('pp-shown');
			$('.open-menu').removeClass('open');
			$('body').removeClass('no-scroll');
		}
	});
}());
